import { getProvider } from '@/apollo'
import gql from 'graphql-tag'

const initialState = {
  bankAccount: {
    iban: '',
    accountHolder: '',
    confirmation: false
  },
  validationStatus: ''
}

const PaymentModule = {
  namespaced: true,
  state: initialState,
  getters: {
    bankAccount: state => {
      return state.bankAccount
    },
    validationStatus: state => state.validationStatus
  },
  actions: {
    async validateAndSavePayment ({ dispatch, commit, state, getters, rootGetters }, { person, address, bankAccount, process = 'ordering' }) {
      commit('setBankAccount', bankAccount)

      const apolloClient = getProvider().defaultClient

      const paymentType = {
        iban: bankAccount.iban,
        owner: bankAccount.accountHolder,
        paymentType: 'bankAccount'
      }

      const validatePaymentInput = {
        firstName: person.firstName,
        lastName: person.lastName,
        gender: person.gender,
        brand: rootGetters.brand,
        market: 'PUC',
        tariffIdentifier: rootGetters[`checkoutv2/${process}/_cart/targetTariff`].tariffId,
        retailerId: rootGetters.retailerId,
        type: 'DELIVERY',
        address: {
          street: address.street,
          houseNumber: address.houseNumber,
          zip: address.zip,
          city: address.city,
          supplement: address.supplement
        },
        paymentType: paymentType
      }

      return apolloClient.mutate({
        mutation: gql`mutation ${process} ($validatePaymentInput: ValidatePaymentInput!) {
          validatePayment (validatePayment: $validatePaymentInput){
            success
          }
        }`,
        variables: {
          validatePaymentInput: validatePaymentInput
        }
      }).then((response) => {
        if (response.data.validatePayment.success) {
          commit('setValidationStatus', 'SUCCESS')
        } else {
          commit('setValidationStatus', 'FAILED')
          throw new Error('Validate Payment failed')
        }
      }).catch((error) => {
        commit('setValidationStatus', 'ERROR')
        throw error
      })
    },
    resetState ({ commit, state }) {
      Object.assign(state, initialState)
    }
  },
  mutations: {
    setBankAccount (state, bankAccount) {
      state.bankAccount = bankAccount
    },
    resetState (state) {
      Object.assign(state, initialState)
    },
    setValidationStatus (state, status) {
      state.validationStatus = status
    }
  }
}

export default PaymentModule
